import { Component, OnInit, Input } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'app-card-module',
  templateUrl: './card-module.component.html'
})
export class CardModuleComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  @Input() cardData: [];
  data: any;
  cardType: string = 'simple';

  constructor() { }

  ngOnInit() {
    // remove this after implementation is done
    // console.log('CardModule component initialized with component data', this.rendering);
    if (!this.cardData) {
      if((this.rendering.fields?.Type as any)?.value.trim() === 'Article') {
        this.cardType = 'article';
        this.data = {
          Title: (this.rendering?.fields?.Title as any)?.value,
          Description: (this.rendering?.fields?.Description as any)?.value,
          Link: {
            href: (this.rendering?.fields?.Link as any)?.value?.href,
            text: (this.rendering?.fields?.Link as any)?.value?.text,
            linktype: (this.rendering?.fields?.Link as any)?.value?.linktype,
            url: (this.rendering?.fields?.Link as any)?.value?.url,
            anchor: (this.rendering?.fields?.Link as any)?.value?.anchor,
            target: (this.rendering?.fields?.Link as any)?.value?.target
          },
          Image: {
            src: (this.rendering.fields?.ArticleImage as any)?.value.src,
            alt: (this.rendering.fields?.ArticleImage as any)?.value.alt
          }
        };
      } 
      else if((this.rendering.fields?.Type as any)?.value.trim() === 'Video') {
        this.cardType = 'video';
        // TODO
      } 
      else {
        this.cardType;
        if((this.rendering?.fields?.File as any)?.value?.src) {
          this.data = {
            Title: (this.rendering?.fields?.Title as any)?.value,
            Description: (this.rendering?.fields?.Description as any)?.value,
            FileHref: (this.rendering?.fields?.File as any)?.value?.src,
            FileText: (this.rendering?.fields?.File as any)?.value?.title,
            FileExtension: (this.rendering?.fields?.File as any)?.value?.extension,
            File1Href: (this.rendering?.fields?.File1 as any)?.value?.src,
            File1Text: (this.rendering?.fields?.File1 as any)?.value?.title,
            File1Extension: (this.rendering?.fields?.File1 as any)?.value?.extension,
            File2Href: (this.rendering?.fields?.File2 as any)?.value?.src,
            File2Text: (this.rendering?.fields?.File2 as any)?.value?.title,
            File2Extension: (this.rendering?.fields?.File2 as any)?.value?.extension,
          };
        }
        else {
          this.data = {
            Title: (this.rendering?.fields?.Title as any)?.value,
            Description: (this.rendering?.fields?.Description as any)?.value,
            Link: {
              href: (this.rendering?.fields?.Link as any)?.value?.href,
              text: (this.rendering?.fields?.Link as any)?.value?.text,
              linktype: (this.rendering?.fields?.Link as any)?.value?.linktype,
              url: (this.rendering?.fields?.Link as any)?.value?.url,
              anchor: (this.rendering?.fields?.Link as any)?.value?.anchor,
              target: (this.rendering?.fields?.Link as any)?.value?.target
            }
          };
        } 
      }
    } else {
      this.cardType = (this.cardData as any)?.Type;
      this.data = {... this.cardData};
    }
  }
}
